module.exports = __webpack_public_path__ + "/dc9baf47e6e311f3fe03d186684e804e.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/assets/salesforce_logo.svg
 ** module id = 1618
 ** module chunks = 0
 **/